import { http } from "../http-common";

// Add this new function to fetch wood suppliers
const getWoodSuppliers = (params = {}) => {
  // Create an array of URLSearchParams for handling multiple values
  let queryParams = [];

  // Add basic parameters
  if (params.pageNumber !== undefined)
    queryParams.push(`pageNumber=${params.pageNumber}`);
  if (params.size !== undefined) queryParams.push(`pageSize=${params.size}`);
  if (params.cropYearId) queryParams.push(`cropYearId=${params.cropYearId}`);
  if (params.seasonCode)
    queryParams.push(`seasonCode=${encodeURIComponent(params.seasonCode)}`);
  if (params.keyword) queryParams.push(`keyword=${encodeURIComponent(params.keyword)}`);
  if (params.ftSurveyFromDate)
    queryParams.push(`ftSurveyFromDate=${params.ftSurveyFromDate}`);
  if (params.ftSurveyToDate) queryParams.push(`ftSurveyToDate=${params.ftSurveyToDate}`);

  // Handle wsSurveyStatuses array parameters (changed from wsSurveyStatus)
  if (params.wsSurveyStatuses && Array.isArray(params.wsSurveyStatuses)) {
    params.wsSurveyStatuses.forEach((status) => {
      queryParams.push(`wsSurveyStatuses=${encodeURIComponent(status)}`);
    });
  }

  // Handle woodSupplierStatuses array parameters (changed from status)
  if (params.woodSupplierStatuses && Array.isArray(params.woodSupplierStatuses)) {
    params.woodSupplierStatuses.forEach((status) => {
      queryParams.push(`woodSupplierStatuses=${encodeURIComponent(status)}`);
    });
  }

  // Handle assignmentStatus array parameters
  if (params.assignmentStatus && Array.isArray(params.assignmentStatus)) {
    params.assignmentStatus.forEach((status) => {
      queryParams.push(`assignmentStatus=${encodeURIComponent(status)}`);
    });
  }

  // Handle isAssigned boolean parameter (replacing the assignmentStatus array)
  if (params.isAssigned !== undefined) {
    queryParams.push(`isAssigned=${params.isAssigned}`);
  }

  // Join all parameters with &
  const queryString = queryParams.join("&");

  // Use the correct endpoint URL structure
  return http.get(`/wood-supplier-task/wood-suppliers?${queryString}`);
};

const getCropStage = (config = {}) => {
  return http.get(`/cropStages`, config);
};

const getCropYear = (config) => {
  return http.get(`/cropYears`, config);
};

const getSurveyApproverData = (params, config = {}) => {
  return http.post(
    `/surveyApprover?pageNumber=${params?.pageNumber}&pageSize=${params?.size}&isVisitCompliance=${params?.isVisitCompliance}`,
    params,
    config
  );
};

const getHierarchyDropdown = (data, config = {}) => {
  return http.get(`/hierarchy/hierarchy-drop-down?isMuv=${data.isMuv}`, config);
};

const reopenSurveys = (params, config = {}) => {
  return http.post(
    `/surveyApprover/updateSurveyStatus?statusToUpdate=${params?.statusToUpdate}`,
    params,
    config
  );
};

const getViewSurvey = (
  surveyHeaderId,
  cropYear,
  headers
) => {
  return http.get(`/wood-supplier-task/survey-data`, {
    params: {
      surveyHeaderId,
      cropYear,
    },
    headers,
  });
};

const fetchPickListSurvey = (data, headers) => {
  return http.post("/picklist", data, headers);
};

// Add the new function to WoodSupplierTaskService
const getCropSeasonDropDown = (cropYearId, config = {}) => {
  return http.get(`/wood-supplier-task/crop-season-drop-down`, {
    params: { cropYearId },
    ...config,
  });
};

// Add this method to WoodSupplierTaskService.jsx
const getUsers = (params = {}) => {
  // Create an array of query parameters
  let queryParams = [];

  // Add roles parameter - this is mandatory
  if (params.roles) {
    queryParams.push(`roles=${encodeURIComponent(params.roles)}`);
  } 

  // Add any additional parameters if needed
  Object.keys(params).forEach((key) => {
    if (key !== "roles" && params[key] !== undefined && params[key] !== null) {
      queryParams.push(`${key}=${encodeURIComponent(params[key])}`);
    }
  });

  // Join all parameters with &
  const queryString = queryParams.join("&");

  // Call the API with the correct endpoint
  return http.get(`/wood-supplier-task/users?${queryString}`);
};

// Function to assign wood suppliers to a user
const assignWoodSuppliers = (payload) => {
  return http.post('/wood-supplier-task/assign`', payload);
};


const approvePermanentIds = (payload) => {
  return http.post('/wood-supplier-task/approve', payload);
};

const getLabelTranslations = (config) => {
  return http.get("/active-reportStaticTranslations", config);
};

const getImageUrl = (fileUrl) => {
  return http.get(`/storage?fileUrl=${fileUrl}`);
};

const WoodSupplierTaskService = {
  getCropYear,
  getCropStage,
  getSurveyApproverData,
  getHierarchyDropdown,
  reopenSurveys,
  getViewSurvey,
  fetchPickListSurvey,
  getWoodSuppliers, // Add the new function to the service object
  getCropSeasonDropDown, // Add the new function
  getUsers, // Export the new method in the service object
  assignWoodSuppliers, // Add this new method to the export
  approvePermanentIds, // Add this method to the export
  getLabelTranslations,
  getImageUrl
};

export default WoodSupplierTaskService;
